export enum GalleryMediaTypes {
  SPIN = "SPIN",
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
}

export interface ClassificationTag {
  label?: string | null;
  category?: string | null;
}

export interface GalleryTemplatedUrl {
  url: string;
  templated: boolean;
  classificationTags?: readonly (ClassificationTag | null)[] | null;
}

interface GalleryImage {
  url: string;
  alt?: string;
  classificationTags?: readonly (ClassificationTag | null)[] | null;
}

export type GalleryAsset = {
  type: GalleryMediaTypes;
  image: GalleryImage;
};

export const groupByCategory = (images: GalleryAsset[]) => {
  const categories: {
    [category: string]: GalleryAsset[];
  } = {};
  categories["All"] = images;
  for (const image of images) {
    const category = image.image?.classificationTags?.[0]?.category;
    if (!!category) {
      if (!categories[category]) {
        categories[category] = [];
      }
      categories[category].push(image);
    }
  }
  return categories;
};

export const getGalleryAssets = ({
  images,
}: {
  images: readonly GalleryTemplatedUrl[];
}): GalleryAsset[] => {
  return images.map(({ url, templated, classificationTags }) => {
    let alt = classificationTags?.[0]?.label;
    alt = alt && alt !== "Inconclusive" ? alt : "vehicle image";
    return {
      type: GalleryMediaTypes.IMAGE,
      image: { url, templated, classificationTags, alt },
    };
  });
};

export const addTrackingLabelPrefix = (label: string) => {
  return `fpa-in-page-${label}`;
};

export const getFullScreenTrackingLabel = (type: GalleryMediaTypes): string => {
  switch (type) {
    case GalleryMediaTypes.IMAGE: {
      return "open-gallery";
    }
    case GalleryMediaTypes.VIDEO: {
      return "play-video";
    }
    case GalleryMediaTypes.SPIN: {
      return "play-360-spin";
    }
  }
};
